export const addChapterUrlParam = (activeChapter: number) => {
  if (activeChapter === 0) {
    return;
  }

  if (typeof activeChapter !== 'number') {
    throw new Error('addChapterUrlParam: Chapter must be a number');
  }

  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('chapter', activeChapter.toString());
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
};
